module.exports = __webpack_public_path__ + "img/search_menu_hover.9a3091d6.svg";